'use strict';
module.exports = require('./RadioButton.vue');